/**
 * CRL-3241 black/white design tokens.
 * Single source for the overhauled palette so screens stay consistent.
 */
export const INK = "#191B1E"; // primary text + filled buttons
export const INK_HOVER = "#000000";
export const TEXT_MUTED = "#64748B";
export const TEXT_FAINT = "#94A3B8";
export const BORDER = "#E2E8F0";
export const BORDER_LIGHT = "#F1F5F9";
// new-design.html `--border-strong`: input / preset-pill borders
export const BORDER_STRONG = "#DEE3EC";
export const PAGE_BG = "#F7F8FA";
export const CARD_BG = "#FFFFFF";
export const SOFT_BG = "#F8FAFC";
export const DANGER = "#E11D48";
export const DANGER_BORDER = "#EF4444";
export const DANGER_BG = "#FEE2E2";
export const SUCCESS = "#16A34A";
export const SUCCESS_BG = "#ECFDF3";

export const RADIUS_CARD = "20px";
export const RADIUS_BUTTON = "14px";

export const CARD_SHADOW = "0px 4px 17px 0px #F1F1F4";

// new-design.html `--red-fg` / `--red-bg`: overdue summary pill
export const OVERDUE_FG = "#FF3030";
export const OVERDUE_BG = "#FFECEC";

// new-design.html `--accent-soft`: focus ring + contact icon hover
export const FOCUS_RING = "#ECEDEF";
